// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2sLmF","name":"ConsentHeader_name__1k58E","birthday":"ConsentHeader_birthday__2IT-8","skeleton":"ConsentHeader_skeleton__XO473"};